import ReactGA from "react-ga4";

export const normalLogin = () => ReactGA.event("login", { method: "OTP" });
export const add_to_cart = (price, id, item_category, title, quantity) =>
  ReactGA.event("add_to_cart", {
    currency: "INR",
    value: price,
    items: [
      {
        item_id: id,
        item_name: title,
        item_category,
        price,
        quantity,
      },
    ],
  });

export const remove_from_cart = (price, id, item_category, title, quantity) =>
  ReactGA.event("remove_from_cart", {
    currency: "INR",
    value: price,
    items: [
      {
        item_id: id,
        item_name: title,
        item_category,
        price,
        quantity,
      },
    ],
  });

const transform_array = (data) => {
  const { totalPrice, digitalCart, physicalCart } = data;
  const corrected =
    digitalCart && typeof digitalCart === "object"
      ? Object.entries(digitalCart)
      : {};
  const corrected2 =
    physicalCart && typeof physicalCart === "object"
      ? Object.entries(physicalCart)
      : {};

  const items = [];

  corrected.forEach((item) => {
    const { productId, title, offerPrice, quantityOrdered } = item[1];
    const newData = {
      item_id: productId,
      item_name: title,
      price: offerPrice,
      quantity: quantityOrdered,
    };
    items.push(newData);
  });
  corrected2.forEach((item) => {
    // console.log(1);
    const { productId, title, offerPrice, quantityOrdered } = item[1];
    // console.log({})
    const newData = {
      item_id: productId,
      item_name: title,
      price: offerPrice,
      quantity: quantityOrdered,
    };

    items.push(newData);
  });
  return { totalPrice, items };
};
export const begin_checkout = (data) => {
  const t = transform_array(data);

  ReactGA.event("begin_checkout", {
    currency: "INR",
    value: t.totalPrice,
    items: t.items,
  });
};

const transform_array2 = (data) => {
  const items = [];
  let totalPrice = 0;
  data.forEach((item) => {
    // console.log(1);
    const { productId, title, offerPrice, quantity } = item;
    // console.log({})
    totalPrice += offerPrice;
    const newData = {
      item_id: productId,
      item_name: title,
      price: offerPrice,
      quantity: quantity,
    };

    items.push(newData);
  });

  return {
    totalPrice: totalPrice,
    items,
  };
};
export const purchase = (data) => {
  const t = transform_array2(data);

  ReactGA.event("purchase", {
    currency: "INR",
    value: t.totalPrice,
    items: t.items,
  });
};

const transform_array_for_select_item = (data) => {
  const values = data[0];
  console.log({ values });
  const { productPrice, productId, variantValue, productTitle } = values;

  return {
    item_list_id: productId,
    item_list_name: productTitle,
    items: [
      {
        item_id: productId,
        item_name: productTitle,
        price: productPrice,
        item_variant: variantValue,
      },
    ],
  };
};

export const select_item = (data) => {
  const items = transform_array_for_select_item(data);
  ReactGA.event("select_item", items);
};
export const view_item = (data) => {
  const items = transform_array_for_select_item(data);
  ReactGA.event("view_item", items);
};
export const view_cart = (data) => {
  const t = transform_array(data);

  ReactGA.event("view_cart", {
    currency: "INR",
    value: t.totalPrice,
    items: t.items,
  });
};

export const refund = () => {
  ReactGA.event("refund", {
    currency: "INR",
    value: 10,
    items: [
      {
        item_id: "SKU_12345",
        item_name: "Stan and Friends Tee",
        price: 10,
        quantity: 1,
      },
    ],
  });
};
const view_item_list_helper = (data, id) => {
  const { category, data: arrayOfItems } = data;
  const items = arrayOfItems.map((item) => {
    return {
      item_id: item.productId,
      item_name: item.productTitle,
      price: item.offerPrice,
    };
  });
  return {
    item_list_id: id,
    item_list_name: category,
    items,
  };
};
export const view_item_list = (data, id) => {
  const items = view_item_list_helper(data, id);
  ReactGA.event("view_item_list", items);
};

export const search_event = (data) => {
  ReactGA.event("search", {
    search_term: data,
  });
};

export const tutorial_begin = () => {
  ReactGA.event("tutorial_begin");
};
export const tutorial_complete = () => {
  ReactGA.event("tutorial_complete");
};

export const select_promotion = (
  creative_name,
  creative_slot,
  promotion_id,
  promotion_name
) => {
  const d = {
    creative_name,
    creative_slot,
    promotion_id,
    promotion_name,
    items: [],
  };
  ReactGA.event("select_promotion", d);
};

export const login_begin = (data) => {
  console.log("Login begin function called");
  ReactGA.event("login_begin", {
    method: "OTP",
  });
};
export const login_complete = (data) => {
  console.log("Login comkpld function called");
  ReactGA.event("login_complete", {
    method: "OTP",
  });
};
